import { MergedPriceAndAvailabilityResponse } from 'services/dealerPriceAvailability/types';
import Price from 'components/price';

export const PriceSection: React.FC<{
  part: MergedPriceAndAvailabilityResponse;
  currency: string;
  isRTL?: boolean;
  currencyLdFeatureFlag?: boolean;
}> = ({ part, currency, isRTL = false, currencyLdFeatureFlag = false }) => {
  return (
    <div className="text-start mt-0.5 mb-0.5">
      <Price
        price={part}
        currency={currency}
        isMobileView
        isRTL={isRTL}
        currencyLdFeatureFlag={currencyLdFeatureFlag}
      />
    </div>
  );
};
